const PasswordResetValidations = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Requerido";
  }

  return errors;
};

export const PasswordResetConfirmationValidations = (values) => {
  const errors = {};

  if (!values.new_password1) {
    errors.new_password1 = "Requerido";
  }

  if (!values.new_password2) {
    errors.new_password2 = "Requerido";
  } else if (values.new_password2 !== values.new_password1) {
    errors.new_password2 = "Deben de coincidir";
  }

  return errors;
};

export default PasswordResetValidations;
